var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.13157 6.11022C4.90448 6.27325 3.4474 5.23978 3.16834 5.23751C2.88927 5.23526 1.41579 6.24496 1.19135 6.07826C0.966915 5.91156 1.49455 4.19938 1.41047 3.93194C1.32638 3.66449 -0.0843891 2.56799 0.00398256 2.30194C0.0923737 2.03588 1.87555 2.01117 2.10264 1.84814C2.32972 1.68512 2.93131 -0.00224961 3.2104 2.25185e-06C3.48944 0.0022737 4.06386 1.69918 4.28829 1.86588C4.51273 2.03256 6.2953 2.08621 6.37941 2.35365C6.46349 2.6211 5.03532 3.69457 4.94693 3.96062C4.85856 4.22668 5.35865 5.94718 5.13157 6.11022Z",
    fill: "#F8B84E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.22a9b7ae53bac2fb4bdf94de7f6b74cf.svg";
export { ForwardRef as ReactComponent };